export const endpoints = {
  admin: {
    user: {
      create: `server/admin/user/create`,
      detail: `server/admin/user/detail`,
      update: `server/admin/user/update`,
      user: `server/admin/user`,
    },
  },
  auth: {
    changeCustomer: `server/auth/change-customer`,
    changeFacility: `server/auth/change-facility`,
    changeLanguage: `server/auth/change-language`,
    changeTheme: `server/auth/change-theme`,
    permissions: `server/auth/permissions`,
    login: `server/auth/login`,
    logout: `server/auth/logout`,
    ping: `server/auth/ping`,
    updateSession: `server/auth/update-session`,
  },
  carrier: {
    list: {
      all: `server/carrier/list`,
      carrier: `server/carrier/list/carrier`,
      deliveryServiceCode: `server/carrier/list/delivery-service-code`,
    },
    carrier: `server/carrier`,
  },
  consignee: {
    consignee: `server/consignee`,
    customerConsignee: `server/consignee/customer`,
    list: {
      all: `server/consignee/list`,
      stateOrProvince: `server/consignee/list/state-or-province`,
    },
  },
  customer: {
    list: {
      all: `server/customer/list`,
      authorized: `server/customer/list/authorized`,
      customer: `server/customer/list/customer`,
      customerDict: `server/customer/list/customer-dict`,
      customerItemUom: `server/customer/list/customer-item-uom`,
      customerStatus: `server/customer/list/customer-status`,
    },
    customerLookup: `server/customer/customer-lookup`,
    detail: {
      detail: `server/customer/detail`,
    },
  },
  facility: {
    list: {
      all: `server/facility/list`,
      authorized: `server/facility/list/authorized`,
      facility: `server/facility/list/facility`,
      facilityDict: `server/facility/list/facility-dict`,
      facilityStatus: `server/facility/list/facility-status`,
    },
    facilityLookup: `server/facility/facility-lookup`,
  },
  file: {
    download: `server/file/download`,
    file: `server/file`,
    info: `server/file/info`,
    upload: `server/file/upload`,
  },
  grid: {
    list: `server/grid/list`,
    load: `server/grid/load`,
    remove: `server/grid/remove`,
    save: `server/grid/save`,
    saveConflictCheck: `server/grid/save-conflict-check`,
  },
  image: {
    getImage: `server/image`,
    deleteImage: `server/image/delete-image`,
    uploadImage: `server/image/upload-image`,
  },
  inventory: {
    inventoryInquiry: `server/inventory`,
    inventoryItemDetail: `server/inventory/item-detail`,
    inventoryLotDetail: `server/inventory/item-lot`,
    list: {
      all: `server/inventory/list`,
      inventoryClass: `server/inventory/list/inventory-class`,
      inventoryStatus: `server/inventory/list/inventory-status`,
    },
  },
  item: {
    list: {
      all: `server/item/list`,
      productGroup: `server/item/list/product-group`,
      customerProductGroup: `server/item/list/customer-product-group`,
      customerRateGroup: `server/item/list/customer-rate-group`,
    },
    item: `server/item`,
    itemLookup: `server/item/lookup`,
    itemLotRequiredCheck: `server/item/lotRequiredCheckOnItem`,
  },
  log: {
    client: `server/log/client`,
    error: `server/log/error`,
  },
  order: {
    list: {
      all: `server/order/list`,
      orderItemStatus: `server/order/list/order-item-status`,
      orderPriority: `server/order/list/order-priority`,
      orderStatus: `server/order/list/order-status`,
      orderType: `server/order/list/order-type`,
    },
    inquiry: {
      attachment: `server/order/inquiry/attachment`,
      cancelOrder: `server/order/inquiry/cancel-order`,
      downloadAttachment: `server/order/inquiry/download-attachment`,
      inquiry: `server/order/inquiry`,
      lockOrder: `server/order/inquiry/lock-order`,
      shippingDetail: `server/order/inquiry/shipping-detail`,
      updateOrder: `server/order/inquiry/update-order`,
      detail: {
        detail: `server/order/inquiry/detail`,
      },
    },
    addItem: `server/order/add-item`,
    create: `server/order/create`,
    deleteItem: `server/order/delete-item`,
    duplicateCheck: `server/order/duplicate-check`,
    updateItem: `server/order/update-item`,
  },
  report: {
    list: {
      all: `server/report/list`,
      folder: `server/report/list/folder`,
      format: `server/report/list/format`,
      status: `server/report/list/status`,
      version: `server/report/list/version`,
    },
    completed: `server/report/completed`,
    download: `server/report/download`,
    generate: `server/report/generate`,
    getParams: `server/report/get-params`,
    lookup: `server/report`,
    refresh: `server/report/refresh`,
    setParams: `server/report/set-params`,
    status: `server/report/status`,
  },
  shipment: {
    list: {
      all: `server/shipment/list`,
      countryCode: `server/shipment/list/country-code`,
      shipmentTerms: `server/shipment/list/shipment-terms`,
      shipmentTypes: `server/shipment/list/shipment-types`,
      shipperStatus: `server/shipment/list/shipper-status`,
      stateOrProvince: `server/shipment/list/state-or-province`,
    },
    supplierLookup: `server/shipment/supplier-lookup`,
  },
  system: {
    list: {
      all: `server/system/list`,
      systemDefault: `server/system/list/system-default`,
    },
  },
  user: {
    list: {
      all: `server/user/list`,
      userForm: `server/user/list/user-form`,
      userGroup: `server/user/list/user-group`,
      userStatus: `server/user/list/user-status`,
    },
    detail: {
      header: `server/user/detail/header`,
      detail: `server/user/detail/detail`,
      facility: `server/user/detail/facility`,
      customer: `server/user/detail/customer`,
      activity: `server/user/detail/activity`,
    },
    user: `server/user`,
  },
} as const;
